import React, { use, useEffect } from 'react';
import { DropdownFilter } from '../../../../../patterns/00-atoms/dropdown/dropdown.tsx';
import { Toggletip } from '../../../../../patterns/00-atoms/toggletip/toggletip.tsx';
import { Checkbox } from '../../../../../patterns/00-atoms/checkbox/checkbox.tsx';
import { RestaurantDetails_getRestaurantDetails_menuCard_categories_entries } from '../../../../../types/graphql-types-generated.ts';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export const dishFilterDefault = (
  entry: RestaurantDetails_getRestaurantDetails_menuCard_categories_entries
) => entry !== null;

export const dishFilter = (filter: Array<string>, entry: any) =>
  (!filter.includes('likes') || entry?.likesCount > 0) &&
  (!filter.includes('vegan') || entry?.isVegan === true) &&
  (!filter.includes('vegetarian') || entry?.isVegetarian === true || entry?.isVegan === true);

export type MenuFilterProps = {
  onChange?: (activeFilter: string) => void;
};

export const MenuFilter: React.FunctionComponent<MenuFilterProps> = ({ onChange }) => {
  const dropdownFilterRef = React.useRef<HTMLDivElement>(null);
  const [activeFilter, setActiveFilter] = React.useState<string[]>([]);
  const [activeFilterCount, setActiveFilterCount] = React.useState<number>(0);
  const checkboxClassName = 'flex-row-reverse justify-between gap-4';

  const isFilterActive = (filter: string) => activeFilter.includes(filter);

  const handleFilterCollection = (checked: boolean, filter: string) => {
    if (checked) {
      activeFilter.push(filter);
    } else {
      activeFilter.splice(activeFilter.indexOf(filter), 1);
    }

    setActiveFilterCount(activeFilter.length);
    setActiveFilter(activeFilter);
    onChange?.(activeFilter.join(','));
    UBTracking.trackEvent.click('menu_filter', 'filter_active', activeFilter.sort().join(':'));
  };

  useEffect(() => {
    if (dropdownFilterRef.current) {
      UBTracking.onTrackTargetView(
        dropdownFilterRef.current,
        'menu_filter',
        'filter_button',
        'open'
      );
    }
  }, []);

  return (
    <>
      <Toggletip
        button={props => (
          <div ref={dropdownFilterRef}>
            <button {...props}>
              <DropdownFilter activeFilterCount={activeFilterCount} />
            </button>
          </div>
        )}
        content={
          <div className="flex flex-col gap-4">
            <Checkbox
              label="Nur Empfehlungen"
              name="likes"
              checked={isFilterActive('likes')}
              onChange={handleFilterCollection}
              className={checkboxClassName}
            />
            <Checkbox
              label="Nur vegane Gerichte"
              name="vegan"
              checked={isFilterActive('vegan')}
              onChange={handleFilterCollection}
              className={checkboxClassName}
            />
            <Checkbox
              label="Nur vegetarische Gerichte"
              name="vegetarian"
              checked={isFilterActive('vegetarian')}
              onChange={handleFilterCollection}
              className={checkboxClassName}
            />
          </div>
        }
        paddingClass="p-4"
        modal={true}
        onOpen={() => UBTracking.trackEvent.click('menu_filter', 'filter_button', 'open')}
        onClose={() => UBTracking.trackEvent.click('menu_filter', 'filter_button', 'close')}
      />
    </>
  );
};
